<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      v-c-emit-root-event:toggle-sidebar-mobile
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      v-c-emit-root-event:toggle-sidebar
    />
    <CHeaderBrand
      class="mx-auto d-lg-none" 
      src="img/spannrit-logo.png"
      width="56"
      height="40"
      alt="Spannrit Logo"
    />
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact :class="{'d-none' : !this.profile.USER_MANAGE_USERS_RIGHT }">
          Benutzer
        </CHeaderNavLink>

        
      </CHeaderNavItem>

    </CHeaderNav>
    
    <CHeaderNav class="mr-4">
     <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      -->
      {{this.profile.username}}
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'TheHeader',
  computed : mapGetters(["isLoading","profile"]),
  components: {
    TheHeaderDropdownAccnt
  }
}
</script>
